/**
 * Shared helpers used by both cell-value-rendering and cell-rendering-scalars.
 * Kept in a separate file to avoid circular imports.
 */

/**
 * Returns Tailwind class names for an engagement-staleness badge based on
 * how many days have passed since the last activity.
 */
export function engagementStalenessBadgeClassNames(daysSince: number): string {
  if (daysSince < 7) {
    return "bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300";
  }
  if (daysSince <= 14) {
    return "bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200";
  }
  return "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300";
}
